export const normalizeString = (stringToNormalize: string) =>
  stringToNormalize.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
